



























import Vue from 'vue'
export default Vue.extend({
  name: '404',
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' })
    },
    goBack() {
      this.$router.go(-1)
    },
  },
})
